<template>
    <main class="config">

    	<el-form>
    		<x-form
    			v-model="uid"
    			label="用户id"
    		></x-form>
    	</el-form>
    	<el-button type="primary" @click="create">确认</el-button>
    	<div class="token">{{token}}</div>
    </main>
</template>

<script type="text/javascript">
import {
	getToken
} from '@/api/common'
export default {
    data() {
        return {
        	uid: '',
        	token: ''
        }
    },
    methods: {
    	create() {
    		if (!this.uid) return
    		getToken({
    			uid: this.uid,
    			key: 'dushuhui'
    		}).then(res => {
    			console.log(res)
    			this.token = res.data
    		})
    	}
    }
}
</script>

<style lang="less">
.token {
	word-break: break-all;
	}
</style>